var render = function render(){var _vm=this,_c=_vm._self._c;return _c('media-object',_vm._b({},'media-object',_vm.itemProps,false),[_c('template',{slot:"after"},[([_vm.$options.modes.LIVE, _vm.$options.modes.POST].includes(_vm.mode))?_c('StatusBadge',{attrs:{"value":_vm.value.status || _vm.$options.status.RUNNING}}):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }